import { z } from "zod";

export const BUILDER_PAGE_TYPES = z.enum([
  "other",
  "blog",
  "get-started",
  "homepage",
  "product-details-page",
  "products",
  "free-trial-PDP",
  "free-trial-landing-page",
  "login-page",
  "account-page",
  "cart",
  "shop",
  "store-locator",
  "product-marketing-page",
  "unsubscribe",
  "contact-page",
  "faq-page",
  "ploom-club-overview",
  "account-ploom-club",
  "ploom-club-points-history",
  "ploom-club-pack-codes",
  "ploom-club-blog",
  "internal-pages",
]);

type BuilderPageType = z.infer<typeof BUILDER_PAGE_TYPES>;

export function isValidBuilderPageType(pageType: string): pageType is BuilderPageType {
  return BUILDER_PAGE_TYPES.safeParse(pageType).success;
}
